module.exports = __webpack_public_path__ + "img/42.fe9902d1.png";